import { createFormHookContexts, createFormHook } from "@tanstack/react-form";
import { FormTextField } from "./form-text-field";
import { FormTextArea } from "./form-text-area";
import { FormSelect } from "./form-select";
import { FormSwitch } from "./form-switch";
import { FormCheckbox } from "./form-checkbox";
import { FormCombobox } from "./form-combobox";
import { FormDatePicker } from "./form-date-picker";
import { MultiSelectCombobox } from "./form-multi-select-combobox";
import { MultiSelectComboboxSortable } from "./form-multi-select-combobox-sortable";
import { FormMultiSwitch } from "./form-multi-switch";
export const { fieldContext, formContext, useFieldContext } = createFormHookContexts();

export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    FormTextField,
    FormTextArea,
    FormSelect,
    FormSwitch,
    FormCheckbox,
    FormCombobox,
    FormDatePicker,
    MultiSelectCombobox,
    MultiSelectComboboxSortable,
    FormMultiSwitch,
  },
  formComponents: {},
});
